define('app/factories/sale_factory',[
  'app/setup',
  'app/views/sale_view',
  'app/views/ticket_sale_view',
  'app/views/offline_hotel_request_form_view',
  'app/collections/sale_collection',
  'app/views/dc_multi_use_modal_view',
  'app/views/dc_lasts_list_view',
  'app/views/campaign_popup_view'],
function(takhfifan, saleView) {
  $(function($) {

    /*
     * Load this view only once we have a form key. Otherwise we get
     * a race condition for sessions, because all requests connecting
     * without a cookie will receive a different session, thereby
     * overwriting the previous session.
     */
    var alreadyInitializedSalesViews = false;

    function initSaleView(){
      if(takhfifan.formKey && !alreadyInitializedSalesViews){
        alreadyInitializedSalesViews = true;
        var deals = new takhfifan.SaleCollection();
        var productIds = [];

        //adding associated products to collection (if exist)
        if($('#tkh-grouped-products-data').length){
          var subDealsData = JSON.parse($('#tkh-grouped-products-data').val());
          _.each(subDealsData, function(subDealData){
            var subSale = new takhfifan.Sale(subDealData);
            productIds.push(subDealData.id);
            deals.push(subSale);
          });
        }

        $('.tkh-sale').each(function(){
          var $el = $(this);
          var dealId = $el.data('product-id');
          productIds.push(dealId);
          var sale = new takhfifan.Sale({id: dealId});
          new takhfifan.SaleView({el: $el, model: sale, collection:deals});
          deals.push(sale);
        });

        //tickets grouped products (like train tickets)
        $('.tkh-ticket-sale').each(function(){
          var $el = $(this);
          var dealId = $el.data('product-id');
          productIds.push(dealId);
          if($('.tkh-associated-products-data').length){
            var associatedData = JSON.parse($('.tkh-associated-products-data').val());
            _.each(associatedData, function(items, key){
              if(key !== dealId){
                var sale = new takhfifan.Sale({id: key});
                deals.push(sale);
                productIds.push(key);
                _.each(items, function(item){
                  var sale = new takhfifan.Sale({id: item});
                  deals.push(sale);
                  productIds.push(item);
                });
              }
            });
          }

          var sale = new takhfifan.Sale({id: dealId});
          new takhfifan.TicketSaleView({el: $el, collection:deals});
          deals.push(sale);
        });

        //offline hotel request form
        $('.tkh-offline-hotel-request__wrapper').each(function(){
          var $el = $(this);
          new takhfifan.OfflineHotelRequestForm({el: $el});
        });

        $('.tkh-latest-dc-body').each(function () {
          new takhfifan.DiscountLastsListView({el: $(this)});
        });

        $('.tkh-campaign-popup').each(function () {
          new takhfifan.campaignPopupView({el: $(this)});
        });

        $('.dc-multi-use-modal-wrapper').each(function(){
            new takhfifan.dcMultiUseModal({el: $(this)})
        });

        //external grouped products (like discount coupons)
        $('.tkh-sale-ext').each(function(){
          var $el = $(this),
              dealId = $el.data("vendorId");
          productIds.push(dealId);

          $('.tkh-dc-soldout-links').each(function(){
            new takhfifan.dcSoldOutLinks({
              el: $(this),
              dealId: dealId,
              deals: deals
            });
          }, this);
          new takhfifan.DiscountListView({el: $(this).find('.tkh-sale-ext-discounts'), vendorId: dealId});

          $('.tkh-dc-verification-modal').each(function(){
            new takhfifan.dcVrifyPhoneNumber({
              el: $(this)
            })
          })
        });

        if(productIds.length){
          var i,j,chunkedArray,chunk = 20;
          for (i=0,j=productIds.length; i<j; i+=chunk) {
            chunkedArray = productIds.slice(i, i + chunk);
            deals.fetch({
              traditional: false,
              data: {id: chunkedArray},
              remove: false,
              reset: false,
              success: function (collection, response, options) {
                collection.trigger('fetched_and_notified');
              }
            });
          }
        }

      }
    }

    initSaleView();

    takhfifan.eventHub.on('formkey', function(formKey) {
      initSaleView();
    });

  });
});

